<template>
  <div class="itineraries-stops-tags">
    <a-tooltip
      v-for="(tag, index) in visibleTags"
      :key="index"
      placement="top"
      overlay-class-name="itineraries-stops-tags__tooltip"
    >
      <template slot="title">
        <div class="itineraries-stops-tags__tooltip-name">{{ tag.nome }}</div>
        <div v-if="tag.cnpj" class="itineraries-stops-tags__tooltip-cnpj">
          {{ tag.cnpj }}
        </div>
      </template>

      <a-tag class="itineraries-stops-tags__tag">
        <span class="itineraries-stops-tags__tag-name">{{ tag.nome }}</span>
        <span v-if="tag.cnpj" class="itineraries-stops-tags__tag-cnpj">{{ tag.cnpj }}</span>
      </a-tag>
    </a-tooltip>

    <a-popover
      v-if="remainingCount > 0"
      trigger="click"
      placement="bottom"
      overlay-class-name="itineraries-stops-tags__popover"
    >
      <template slot="content">
        <div class="itineraries-stops-tags__popover-title">Mais paradas</div>

        <div
          class="itineraries-stops-tags__popover-list"
          :class="{ 'itineraries-stops-tags__popover-list--scroll': expanded }"
        >
          <div
            v-for="(tag, index) in displayedRemaining"
            :key="index"
            class="itineraries-stops-tags__popover-item"
          >
            <span class="itineraries-stops-tags__popover-name">{{ tag.nome }}</span>
            <span
              v-if="tag.cnpj"
              class="itineraries-stops-tags__popover-cnpj"
              >{{ tag.cnpj }}</span
            >
          </div>
        </div>

        <a
          v-if="hasMoreToExpand"
          class="itineraries-stops-tags__ver-mais"
          @click="expanded = true"
        >
          Ver mais
        </a>
      </template>

      <a-tag class="itineraries-stops-tags__tag itineraries-stops-tags__tag--more">
        +{{ remainingCount }}
      </a-tag>
    </a-popover>
  </div>
</template>

<script>
export default {
  name: 'ItinerariesStopsTags',
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    visibleCount: {
      type: Number,
      default: 2,
    },
    previewCount: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    visibleTags() {
      return this.tags.slice(0, this.visibleCount);
    },
    remainingTags() {
      return this.tags.slice(this.visibleCount);
    },
    remainingCount() {
      return this.remainingTags.length;
    },
    displayedRemaining() {
      return this.expanded
        ? this.remainingTags
        : this.remainingTags.slice(0, this.previewCount);
    },
    hasMoreToExpand() {
      return !this.expanded && this.remainingTags.length > this.previewCount;
    },
  },
};
</script>

<style scoped lang="less">
@import '~@/shared/styles/variables.less';

@stop-tag-max-width: 180px;

.itineraries-stops-tags {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;

  &__tag {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: @stop-tag-max-width;
    height: auto;
    padding: 3px 8px;
    line-height: 16px;
    background-color: @color-tag-bg;
    border-color: @color-tag-border;
    color: @color-tag-text;
    font-size: 12px;
    font-weight: 500;
    margin-right: 0;
  }

  &__tag-name {
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__tag-cnpj {
    font-size: 11px;
    font-weight: 400;
    opacity: 0.75;
  }

  &__tag--more {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>

<style lang="less">
@import '~@/shared/styles/variables.less';

.itineraries-stops-tags__tooltip {
  max-width: 320px;

  .itineraries-stops-tags__tooltip-name {
    font-weight: 600;
  }

  .itineraries-stops-tags__tooltip-cnpj {
    font-size: 12px;
    opacity: 0.85;
  }
}

.itineraries-stops-tags__popover {
  .ant-popover-inner-content {
    width: 265px;
    padding: 16px;
  }
}

.itineraries-stops-tags__popover-title {
  font-size: 14px;
  font-weight: 600;
  color: @color-text-dark;
  margin-bottom: 8px;
}

.itineraries-stops-tags__popover-list {
  font-size: 14px;
  color: @color-text-dark;

  &--scroll {
    max-height: 96px;
    overflow-y: auto;
    padding-right: 4px;
  }
}

.itineraries-stops-tags__popover-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
}

.itineraries-stops-tags__popover-cnpj {
  font-size: 12px;
  color: @color-text-light;
}

.itineraries-stops-tags__ver-mais {
  display: inline-block;
  margin-top: 8px;
  color: @color-link;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
